module.exports = __webpack_public_path__ + "img/今日新增项目@2x.4ff94677.png";